import Loader from "react-spinners/BeatLoader";

const LoadingSpinner = () => {
    return (
        <Loader  color={'#0d6efd'} />
    );
  };

  export default LoadingSpinner;
